//TODO on repeat field add set courser to the first added element

window.kickstartjs.extend({
    addRequiredRepeatFields: function() {
        jQuery('.repeat-field').each(function() {
            var parentId = jQuery(this).data('parent-id');
            var fieldId = jQuery(this).data('field-id');

            if (typeof parentId === 'undefined' || typeof fieldId === 'undefined') {
                console.log('Was not able to get parent "' + parentId + '" or field "' + fieldId + '" id!');
                return;
            }
            console.log('add repeat field/s to the "' + fieldId + '" field of parent "' + parentId + '".');
            var partId = parentId + '-' + fieldId;
            var repeatCountId = partId + '-counter';
            var value = jQuery('#' +partId + '-repeats .single-repeat-field').length;
            jQuery('#' + parentId + '-hidden').append('<input type="hidden" id="' + repeatCountId + '" value="' + value + '">');
            var minFields = parseInt(jQuery('#' + partId + '-repeats').data('repeat-min'));

            if(isNaN(minFields)) {
                return;
            }

            if(value >= minFields) {
                jQuery('.btn-repeat-remove').click(window.kickstartjs.clickBtnRemoveRepeatField);
                return;
            }

            for(var i = value; i < minFields; i++) {
                window.kickstartjs.addRepeatField(parentId, fieldId);
            }
        });
    },

    addRepeatField: function(parentId, fieldId) {
        if (typeof parentId === 'undefined' || typeof fieldId === 'undefined') {
            console.log('parentId or fieldId are not set! Not able to add a repeat field.');
            return;
        }

        var partId = '#' + parentId + '-' + fieldId;
        var repeatFieldCounter = jQuery(partId + '-counter');

        if (typeof repeatFieldCounter === 'undefined') {
            console.log('Was not able to find the counter field.');
            return;
        }

        var count = parseInt(repeatFieldCounter.val());
        var maxFields = parseInt(jQuery(partId + '-repeats').data('repeat-max'));

        if(isNaN(maxFields)) { //TODO remove minFields and maxFields required
            console.log('Was not able to load the max fields of "'+partId+'" value!');
            return;
        }

        if (count + 1 > maxFields) {
            console.log('There are to many fields you cant add more to "'+partId+'".');
            return;
        }

        console.log('add new repeat field "' + fieldId + '" to parent "' + parentId + '".');
        var tempData = jQuery(partId + '-repeat-template').html();
        tempData = tempData.replace(new RegExp('##nr##', 'g'), count);
        tempData = tempData.replace(new RegExp('data-template-name( )?=( )?"', 'g'), 'name="');
        jQuery(partId + '-repeats').append(tempData);

        var btn = jQuery('.btn-repeat-remove');
        btn.unbind("click");
        btn.click(window.kickstartjs.clickBtnRemoveRepeatField);

        repeatFieldCounter.val(count + 1);
    },

    removeRepeatField: function(parentId, fieldId, counter) {
        if (typeof parentId === 'undefined' || typeof fieldId === 'undefined' || typeof counter === 'undefined') {
            console.log('formId, fieldId or counter is not set!');
            return;
        }

        var partId = '#' + parentId + '-' + fieldId;
        var repeatFieldCounter = jQuery('#' + parentId + '-' + fieldId + '-counter');

        if (typeof repeatFieldCounter === 'undefined') {
            console.log('Was not able to find the counter field.');
            return;
        }
        var count = parseInt(repeatFieldCounter.val());
        var minFields = parseInt(jQuery(partId + '-repeats').data('repeat-min'));

        if(isNaN(minFields)) {
            minFields = 0;
        }

        if (count - 1 < minFields || count - 1 < 0) {
            console.log('Not able to delete more Fields. They are required.');
            return;
        }

        console.log('remove ' + counter + ' field "' + fieldId + '" from parent "' + parentId + '".');

        var singleFieldId = partId + '-single-repeat-field-' + counter;
        var wasLast = jQuery(singleFieldId).is(':last-child');
        jQuery(singleFieldId).detach();
        repeatFieldCounter.val(count - 1);

        if (wasLast) {
            return;
        }

        console.log('reduce the counter of all other fields');

        for (var i = counter + 1; i < count; i++) {
            singleFieldId = partId + '-single-repeat-field-' + i;
            var newSingeFieldId = partId + '-single-repeat-field-' + (i - 1);
            var field = jQuery(singleFieldId);
            field.attr('id', newSingeFieldId.replace('#', ''));
            console.log('change ' + singleFieldId + ' to ' + newSingeFieldId);
            var regExp = '(for|id|class|name|data-counter)( )?=( )?"([a-zA-Z\\-\\[\\]]*)' + i + '([a-zA-Z\\-\\[\\]]*)"';
            field.html(field.html().replace(new RegExp(regExp, 'g'), '$1="$4' + (i - 1) + '$5"'));
        }
    },

    clickBtnRemoveRepeatField: function() {
        var parent = window.kickstartjs.getParent(this, '.repeat-field');
        var parentId = parent.data('parent-id');
        var fieldId = parent.data('field-id');
        var counter = parseInt(jQuery(this).data('counter'));
        window.kickstartjs.removeRepeatField(parentId, fieldId, counter);
    }
});

jQuery(document).ready(function($) {
    window.kickstartjs.addRequiredRepeatFields();
    $('.btn-repeat-add').click(function() {
        var parent = window.kickstartjs.getParent(this, '.repeat-field');
        var parentId = parent.data('parent-id');
        var fieldId = parent.data('field-id');
        window.kickstartjs.addRepeatField(parentId, fieldId);
    });
});